import { Button } from 'iq-blueberry'
import * as classNames from 'classnames'
import OutlineAngleRightMini from 'iq-blueberry/dist/reactIcons/OutlineAngleRightMini'

import ActionButtons from 'components/common/ActionButtons'
import FormContainer from 'components/common/FormContainer'
import TokenInput from 'components/common/TokenInput'

import './style.styl'
import useSMSTokenStep from './hook'
import MessageBox from 'components/common/MessageBox '
import { FormTitle } from 'components/common/FormTitle'

const SMSStepTemplate = (props = {}) => {
  const { fireboltStep } = props
  const {
    currentFormRef,
    timeToExpire,
    onChangeTimerHandler,
    onCompleteTokenHandler,
    userTelephone,
    token,
    sendToken,
    tokenError,
    isErrorVisible,
  } = useSMSTokenStep(props)

  return (
    <>
      <FormContainer imageSrc="images/bb/ourocard-novo.png">
        <div className="sms-token-step-template">
          <FormTitle
            title={`Digite o código que enviamos por SMS para o número ${userTelephone}`}
          />
          <p
            className={classNames('sms-token-step-template__label', {
              'sms-token-step-template__label--error': isErrorVisible,
            })}>
            Código de 4 dígitos
          </p>
          <div
            className="sms-token-step-template__token-holder"
            ref={currentFormRef}>
            <TokenInput
              size={4}
              onCompleteToken={onCompleteTokenHandler}
              onChangeTimer={onChangeTimerHandler}
              timer={55}
              isError={isErrorVisible}
              errorMessage={tokenError}
            />
          </div>
          {timeToExpire ? (
            <MessageBox icon={false}>
              Seu código expira em <strong>{timeToExpire} segundos</strong>
            </MessageBox>
          ) : (
            <Button
              type="text"
              size="small"
              className="sms-token-step-template__expiring-text"
              Icon={OutlineAngleRightMini}
              onClick={fireboltStep?.goPreviousStep}>
              Reenviar código
            </Button>
          )}
          <ActionButtons
            isStepValid={!!token}
            onGoBack={fireboltStep?.goPreviousStep}
            onSubmit={sendToken}
          />
        </div>
      </FormContainer>
    </>
  )
}

export default SMSStepTemplate
